export { default as LoyaltyHistory } from './loyalty-history';
